<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Workspace'})"/>
                {{ $t('health.nutritionalPlan.menu') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>

        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="4">
            <div class="center-horizontal">

              <!-- Calendar -->
              <safe-router-link to="/calendar" class="nav__menu-item">
                <div v-has-feature="'NutritionalPlan'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.calendarEdit"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.nutritionalPlan.calendar') }}</div>
                </div>
              </safe-router-link>

              <!-- Ingests -->
              <safe-router-link to="/ingest" class="nav__menu-item">
                <div v-has-feature="'NutritionalPlan'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.utensils"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.nutritionalPlan.title') }}</div>
                </div>
              </safe-router-link>

              <!-- Templates -->
              <safe-router-link to="/ingest/templates" class="nav__menu-item">
                <div v-has-feature="'NutritionalPlan'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.file"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('health.nutritionalPlan.templates') }}</div>
                </div>
              </safe-router-link>

            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import {faCalendarEdit, faUtensils, faFile} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import SafeRouterLink from '@/components/shared/SafeRouterLink';
import Chevron from '@/components/shared/Chevron';

export default {
  name: 'NutritionalPlanMenu',
  components: {
    SafeRouterLink,
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon,
    Chevron
  },
  data () {
    return {
      icons: {
        calendarEdit: faCalendarEdit,
        utensils: faUtensils,
        file: faFile
      }
    };
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.workspace'),
          link: '/workspace'
        },
        {
          name: this.$t('health.nutritionalPlan.menu'),
          link: '/nutritionalPlan',
          disabled: true
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.buttons {
  text-align: center;
}

.personal-area-element {
  align-items: center;
  display: inline-block;
  text-align: center;
  background-color: $black-light9;
  border: solid 0.2rem $black-light9;
  border-radius: $radius;
  height: 15rem;
  width: 15rem;
  color: $secondary;
  margin: 1rem;
  padding-top: 2.7rem;
}

.personal-area-element:hover {
  border: solid 0.2rem $black-light5;
}

.personal-area-element-icon {
  font-size: 7rem;
}

.personal-area-element-title {
  font-size: 1.3rem;
  font-weight: bold;
}

.disabled, .disabled:hover{
  color: $secondary-trans7;
  border: solid 0.2rem $black-light9;
}

.center-horizontal {
  display: table;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/NutritionalPlanMenu.vue